import React from 'react';
import { Box, Skeleton, VStack, Text } from '@skin-seoul/design-system';
const IngredientRatingsSectionSkeleton = () => {
  return <Box background="white" position="relative" width="100%" data-sentry-element="Box" data-sentry-component="IngredientRatingsSectionSkeleton" data-sentry-source-file="IngredientRatingsSection.skeleton.tsx">
      {/* Top border */}
      <Box position="absolute" top={0} left={0} right={0} height="1px" background="neutral.100" pointerEvents="none" data-sentry-element="Box" data-sentry-source-file="IngredientRatingsSection.skeleton.tsx" />

      <VStack alignItems="flex-start" justifyContent="center" paddingX={{
      base: 4,
      tablet: 0
    }} paddingY={5} width="100%" gap={6} data-sentry-element="VStack" data-sentry-source-file="IngredientRatingsSection.skeleton.tsx">
        {/* Title */}
        <Text textStyle={{
        base: 'label.large',
        tablet: 'heading.h6'
      }} fontWeight="medium" color="neutral.800" textAlign="left" whiteSpace="nowrap" letterSpacing={{
        tablet: '-0.4px'
      }} data-sentry-element="Text" data-sentry-source-file="IngredientRatingsSection.skeleton.tsx">
          Ingredient Ratings
        </Text>

        <VStack gap={4} width="100%" alignItems="stretch" data-sentry-element="VStack" data-sentry-source-file="IngredientRatingsSection.skeleton.tsx">
          {Array.from({
          length: 3
        }).map((_, index) => <Skeleton key={index} height="60px" borderRadius={8} />)}
        </VStack>
      </VStack>
    </Box>;
};
export default IngredientRatingsSectionSkeleton;